import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import { LISTINGS } from 'containers/data-structure';
import { get, isEmpty, isNil } from 'lodash';
import {
  RISK_NAME,
  STAKE_HOLDERS_TYPES,
} from 'containers/CourtManagerLegalProceedings/Provision/constants';
import { translate } from 'containers/services/translate';
import { PROVISION_INTERVENANT_FIELDS } from 'containers/RecapManagerPage/constants';

export const getProvisionInfo = (sagisClaim: any) => {
  return get(sagisClaim, 'offeredRisks', []).map((el: any) => {
    return {
      riskId: el.riskId,
      riskName: el.riskName,
      riskNature: el.riskNature,
      managementMode: el.managementMode,
      responsibilityRate: el.responsibilityRate,
      provision: el.riskProvisions,
      regulation: el.riskPayments,
      provisionRecEmis: el.riskProvisionRecorveryEmis,
      recoursEmisRec: el.riskclaimedRecorveryEmis,
      recoursRec: el.riskRecorveryPaidBack,
      provisionHistory: el.provisionHistory,
      contractorFees: get(sagisClaim, 'contractorFees', []),
    };
  });
};
export const sumValue = (array: any[]) => {
  const sum = array.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0.0,
  );
  return sum as Number;
};
export const getGlobalProvisionDetailInfo = (risk: any) => {
  return get(risk, 'provisionHistory', []).map((el: any) => {
    return {
      provisionType: el.motivation,
      provisionAmount: el.amount,
      provisionDate: el.createdAt,
      provisionAuthor: el.author,
    };
  });
};

export const getOpposingPartyDetailInfo = (risk: any) => {
  return get(risk, 'opposingParties', []).map((el: any) => {
    return {
      firstName: el.firstName,
      lastName: el.lastName,
      insuranceCompanyName: el.insuranceCompanyName,
      provisionAmount: '-',
      regulation: '-',
    };
  });
};

export const getIntervenantDetailInfo = (
  risk: any,
  riskKey: string,
  listings: Listings,
) => {
  return !isEmpty(
    get(risk, 'contractorFees', []).filter(
      (item: any) => item.riskKey === riskKey,
    ),
  )
    ? get(risk, 'contractorFees', [])
        .filter((item: any) => item.riskKey === riskKey)
        .map((el: any) => {
          return {
            intervenantType: getValueByCode(
              el.contractorTypeCode,
              get(listings, LISTINGS.INTERVENANT_TYPE, []),
            ),
            intervenantTypeCode: el.contractorTypeCode,
            intervenantName:
              getValueByCode(
                el.contractorCode,
                get(listings, LISTINGS.INTERVENANT_NAME, []),
              ) != ''
                ? getValueByCode(
                    el.contractorCode,
                    get(listings, LISTINGS.INTERVENANT_NAME, []),
                  )
                : getValueByCode(
                    el.contractorCode,
                    get(listings, LISTINGS.INACTIFS_INTERVENANT_NAME, []),
                  ) + ' (Inactif)',
            provision: el.amount,
            regulation: '-',
            designatedField: '-',
            intervenantCode: el.contractorCode,
          };
        })
    : [];
};

export const getValueByCode = (code: string, list: any = []) => {
  if (isNil(list)) {
    return '';
  } else {
    const item = list.find(
      (item: any) => Number(item.ItemKey) === Number(code),
    );
    return item ? item.ItemDescription : '';
  }
};

export const resolveLabel = (item: any) => {
  if (typeof item['id'] === 'string') return item['id'];
  return item.firstName && !item.registrationNumber
    ? `${item.firstName} ${item.lastName}`
    : item.registrationNumber;
};

export const resolveRiskName = (riskName: string) => {
  if (riskName === RISK_NAME.CORPOREAL || riskName === RISK_NAME.MATERIEL)
    return riskName;
  return RISK_NAME.GARANTIES_ANNEXES;
};

export const getAdditionalGuarantees = (sagisClaim: any) =>
  getProvisionInfo(sagisClaim).filter(
    (el: any) =>
      el.riskName !== RISK_NAME.CORPOREAL && el.riskName !== RISK_NAME.MATERIEL,
  );
export const getStakeHoldersTypes = (messages: any, props: any) => {
  return Object.keys(STAKE_HOLDERS_TYPES).map((key: any) => {
    const type = key.toLowerCase() + 'StakeHolder';
    return {
      id: STAKE_HOLDERS_TYPES[key],
      title: translate(messages[type], props),
    };
  });
};
export const getStakeHolders = (
  stakeHolders: SagisConfig[],
  currentStakeHolder: any,
  provision: any,
) => {
  const provisionContractorCode = provision.map(
    (el: any) => el.intervenantCode,
  );
  return (
    stakeHolders.filter(
      item =>
        item.ItemType ===
          String(
            get(
              currentStakeHolder,
              PROVISION_INTERVENANT_FIELDS.CONTRACTOR_TYPE_CODE,
              '',
            ),
          ) && !provisionContractorCode.includes(String(item.ItemKey)),
    ) || []
  );
};
